import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const DAY_OPTIONS = [
  { label: "0–7 days", value: "0-7" },
  { label: "7–15 days", value: "7-15" },
  { label: "15–30 days", value: "15-30" },
];

export default function LeadSelect() {
  const [days, setDays] = useState("0-7");
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError("");

    fetch(
      `https://backend.trustnride.in/api/lead/check?days=${days}`
    )
      .then((res) => res.json())
      .then((response) => {
        if (Array.isArray(response.data)) {
          setLeads(response.data);
        } else {
          setLeads([]);
        }
      })
      .catch(() => {
        setError("Failed to fetch leads");
        setLeads([]);
      })
      .finally(() => setLoading(false));
  }, [days]);

  return (
    <div>
      <Navbar />

      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-5xl mx-auto">

          {/* Heading */}
          <h1 className="text-2xl font-semibold mb-6">
            Send Message to Lead
          </h1>

          {/* Days Dropdown */}
          <div className="mb-6">
            <select
              value={days}
              onChange={(e) => setDays(e.target.value)}
              className="border px-3 py-2 rounded"
            >
              {DAY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {/* Loading */}
          {loading && (
            <p className="text-gray-500">Loading leads...</p>
          )}

          {/* Error */}
          {error && (
            <p className="text-red-600 mb-4">{error}</p>
          )}

          {/* Empty */}
          {!loading && leads.length === 0 && !error && (
            <p className="text-gray-500">
              No leads found for selected days
            </p>
          )}

          {/* Leads Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {leads.map((lead) => (
              <div
                key={lead._id}
                className="bg-white border rounded-lg p-4 shadow-sm"
              >
                <p className="mb-1">
                  <b>Model:</b> {lead.model || "-"}
                </p>

                <p className="mb-1">
                  <b>Year:</b>{" "}
                  {lead.registrationYear ||
                    (lead.registrationDate
                      ? new Date(lead.registrationDate).getFullYear()
                      : "-")}
                </p>

                <p className="mb-1">
                  <b>Vehicle No:</b> {lead.vehicleNumber || "-"}
                </p>

                <p className="mb-3">
                  <b>Owner:</b> {lead.mobileNumber || "-"}
                </p>

                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                  onClick={() =>
                    navigate(`/send/${lead.leadId || lead._id}`, {
                      state: {
                        leadId: lead.leadId || lead._id,
                        model: lead.model,
                        minPrice: lead.minPrice,
                        maxPrice: lead.maxPrice,
                        vehicleNumber: lead.vehicleNumber,
                        mobileNumber: lead.mobileNumber,
                        registrationYear:
                          lead.registrationYear ||
                          (lead.registrationDate
                            ? new Date(
                                lead.registrationDate
                              ).getFullYear()
                            : null),
                      },
                    })
                  }
                >
                  Send Message
                </button>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
